import { useState, useEffect, useRef } from "react"
import { useHistory } from "react-router-dom"
import { WellnessCalendarUtilizationCard } from "../atoms"
import { DownloadPngButton } from '../../opdClaims/primitives'
import { OverviewCalendarEmptyIllustration } from '../../overview/OverviewSectionIcon'
import { handleAppError } from "../../handlers"
import { OverviewApi } from "../../../services"
import { SpinnerDotted } from "../../common/atoms"

const WellnessCalendarCard = ({ contractId, startDate, endDate, classes = '' }) => {
  const [state, setState] = useState({ loading: true })
  const history = useHistory()
  const cardRef = useRef(null)

  useEffect(() => {
    if (!contractId) return

    setState(prevState => { return { ...prevState, loading: true } })
    OverviewApi.fetchWellnessCalendarOverview({ contract_id: contractId, start_date: startDate, end_date: endDate },
      (res) => {
        setState({ ...res.data, loading: false })
      },
      (err) => handleAppError(err)
    )
  }, [contractId])

  const { sponsored, upcoming_events = [], completed_events = [], loading } = state

  return (
    <div
      ref={cardRef}
      className={`rounded-[14px] border border-gray-300 bg-white p-6 ${classes}`}
    >
      <div className='flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between'>
        <div className='flex items-center gap-3'>
          <span
            className='flex shrink-0 items-center justify-center rounded-[10px] bg-blue-100 font-jetbrains-mono text-[10px] font-semibold text-blue-800'
            style={{ width: 38, height: 38 }}
            aria-hidden
          >
            CAL
          </span>
          <p className='mb-0 text-sm font-semibold leading-snug text-gray-900'>Wellness calendar</p>
          {sponsored && (
            <span className='inline-flex shrink-0 rounded-full bg-green-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[.06em] text-green-800'>
              Sponsored
            </span>
          )}
          <DownloadPngButton nodeRef={cardRef} fileName='wellness-calendar' />
        </div>
        <div className='flex flex-wrap gap-2 sm:justify-end' data-download-ignore='true'>
          <button
            type='button'
            className='rounded-[10px] border border-transparent bg-blue-600 px-3.5 py-2 text-[13px] font-medium text-white transition-colors hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2'
            onClick={() => history.push('/wellness-calendar/create-event')}
          >
            Create an event
          </button>
          <button
            type='button'
            className='rounded-[10px] border border-gray-300 bg-white px-3.5 py-2 text-[13px] font-medium text-gray-700 transition-colors hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2'
            onClick={() => history.push('/wellness-calendar')}
          >
            Wellness calendar
          </button>
        </div>
      </div>
      {
        !loading ?
          <>
            {(upcoming_events.length <= 0 && completed_events.length <= 0) ?
              <div className='flex flex-col'>
                <h3 className='mb-0 mt-5 text-[11px] font-semibold uppercase tracking-[.08em] text-gray-600'>{'UPCOMING/COMPLETED EVENTS'}</h3>
                <div className="flex flex-col items-center">
                  <OverviewCalendarEmptyIllustration className='mx-auto h-28 w-28 text-gray-300' />
                  <h3 className="font-semibold text-base text-gray-700 mb-0">No upcoming/completed events</h3>
                </div>
              </div>
              :
              <>
                <div className='flex flex-col'>
                  <h3 className='mb-0 mt-5 text-[11px] font-semibold uppercase tracking-[.08em] text-gray-600'>{'LIVE / UPCOMING EVENTS'}</h3>
                  {upcoming_events.length > 0 ?
                    <div className='mt-2.5 grid grid-cols-1 gap-3.5 md:grid-cols-2'>
                      {upcoming_events.map((item, index) => (
                        <WellnessCalendarUtilizationCard
                          key={`${item.name}-${index}`}
                          tone='live'
                          title={item.name}
                          date={item.event_date}
                          time={item.event_time}
                          participants={item.total_participants}
                        />
                      ))}
                    </div>
                    :
                    <h3 className="font-semibold text-base text-gray-700 flex flex-col items-center my-6 mb-0">No live/upcoming events</h3>
                  }
                </div>
                <div className='flex flex-col'>
                  <h3 className='mb-0 mt-5 text-[11px] font-semibold uppercase tracking-[.08em] text-gray-600'>{'COMPLETED EVENTS'}</h3>
                  {completed_events.length > 0 ?
                    <div className='mt-2.5 grid grid-cols-1 gap-3.5 sm:grid-cols-2 xl:grid-cols-3'>
                      {completed_events.map((item, index) => (
                        <WellnessCalendarUtilizationCard
                          key={`${item.name}-${index}`}
                          tone='done'
                          title={item.name}
                          date={item.event_date}
                          time={item.event_time}
                          participants={item.total_participants}
                        />
                      ))}
                    </div>
                    :
                    <h3 className="font-semibold text-base text-gray-700 flex flex-col items-center my-6 mb-0">No completed events</h3>
                  }
                </div>
              </>
            }
          </> :
          <div className='h-40 flex items-center justify-center'><SpinnerDotted /></div>
      }
    </div>
  )
}

export default WellnessCalendarCard
